import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=43538a4f&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=43538a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43538a4f",
  null
  
)

export default component.exports